module.exports = __webpack_public_path__ + "img/19.6a241d3e.jpg";